import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, Suggest2, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Checkbox, Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";


import { AxiosInstance } from 'axios';

import * as utils from "../utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from '../svg/wait2.gif'

import { FBSMarketInfo } from '../Types'
import { SystemHeader } from '../CommonUI';
import { Pagination, PageInfo } from '../CommonUI';

import i18next from 'i18next';


var GsbFlag: any;

var UserID: string;
var PgmCode = "M0007" ;
var isReqAuth2:boolean = false ;

interface FBSMarketMastViewProps {
    gsb: AxiosInstance,
    MarketInfo: FBSMarketInfo,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
}


export function FBSMarketMastView({ gsb, MarketInfo = {} as FBSMarketInfo, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { } }: FBSMarketMastViewProps) {


    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
    
/*
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
*/

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            //setisReqAuth(true)
                            //isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, MarketInfo])

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    if (! ("d_Market" in MarketInfo)) return null


    return (
        <div>
            {/* define add,change,delete button */}
            <div className="Row">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                
                <Button className="Col-2-1" disabled={isReadOnly} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={isReadOnly} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
            </div>

            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Exchange">
                    <InputGroup readOnly value={MarketInfo.d_Market} />
                </FormGroup>
                <FormGroup className="Col-2-3" label="Name">
                    <div id="DispText">{MarketInfo.d_MarketName}</div>
                </FormGroup>
                <FormGroup className="Col-5-1" label="Complex">
                    <InputGroup readOnly value={MarketInfo.d_Complex} />
                </FormGroup>
                <FormGroup className="Col-6-1" label="SPAN Version">
                    <InputGroup readOnly value={MarketInfo.d_SpanSpecV} />
                </FormGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-2" disabled inline selectedValue={utils.numToString(MarketInfo.d_Margin)} label="Margin Calculation" onChange={()=>{}}>
                    <Radio label="Simplified" value="0" />
                    <Radio label="SPAN" value="1" />
                </RadioGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Main. Margin %" subLabel="(% of Init. Margin for SPAN)">
                    <InputGroup readOnly type='number' value={utils.numToString(MarketInfo.d_OptMM)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Client Margin Multiplier">
                    <InputGroup readOnly type='number' value={utils.numToString(MarketInfo.d_ClMgnMult)} />
                </FormGroup>
            </div>
        </div>
    )
}

interface FBSMarketMastEditProps {
    gsb: AxiosInstance,
    MarketInfo?: FBSMarketInfo,
    isNew?: boolean,
    onSave?: (stk: FBSMarketInfo) => void,
    onCancel?: () => void,
}

export function FBSMarketMastEdit({ gsb, MarketInfo = {} as FBSMarketInfo, isNew = false, onSave = () => { }, onCancel = () => { } }: FBSMarketMastEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<FBSMarketInfo>()

    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)

    const [MarginCalcValue, setMarginCalcValue] = useState(utils.numToString(MarketInfo.d_Margin))

    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        // Call reset to get the values of record ClientTranInfo 
        if ("d_Market" in MarketInfo) {
            reset(MarketInfo)
        }
    }, [MarketInfo, reset])


    useEffect(() => {
        // Some components (e.g. Suggest) don't have ref to use with react-hook-form, so register the fields manually and call setValue when item is selected
        // register({ name: "d_FieldName" })
    }, [register])


    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    if (! isNew && ! ("d_Market" in MarketInfo)) return null

   
    const onSubmit = (data: FBSMarketInfo) => {
        // put value to json/field before write database dbf
        data.d_Margin = utils.StringToNum(MarginCalcValue);

        (async () => {
            try {
                const res = await gsb.post('/fbs/Master', {sb_data: data, cPgmId: "MarketMast", cAction: "MarketMastValidate", isNew: isNew})

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }

                    return
                }
                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }

             </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Exchange" labelFor="inputMarket" labelInfo="*">
                    <InputGroup disabled={!isNew} id="inputMarket" name="d_Market" defaultValue={MarketInfo.d_Market} placeholder="Exchange ..." onChange={utils.handleStringChange(s => setValue("d_Market", s.toUpperCase()))} inputRef={register({ required: true , maxLength: 3}) } />
                    {errors.d_Market && errors.d_Market.type === "required" && <span id="Err_msg">Market cannot be Blank</span>}
                    {errors.d_Market && errors.d_Market.type === "maxLength" && <span id="Err_msg">Max length is 3</span>}
                    {errors.d_Market && errors.d_Market.types && <span id="Err_msg">{errors.d_Market.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-3" label="Name" labelFor="inputMarketName" labelInfo="*">
                    <InputGroup id="inputMarketName" name="d_MarketName" defaultValue={MarketInfo.d_MarketName} placeholder="Exchange Name ..." onChange={utils.handleStringChange(s => setValue("d_MarketName", s.toUpperCase()))} inputRef={register({ required: true , maxLength: 35}) } />
                    {errors.d_MarketName && errors.d_MarketName.type === "required" && <span id="Err_msg">Exchange Name cannot be Blank</span>}
                    {errors.d_MarketName && errors.d_MarketName.type === "maxLength" && <span id="Err_msg">Max length is 35</span>}
                    {errors.d_MarketName && errors.d_MarketName.types && <span id="Err_msg">{errors.d_MarketName.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-5-1" label="Complex" labelFor="d_Complex">
                    <InputGroup id="d_Complex" name="d_Complex" defaultValue={MarketInfo.d_Complex} placeholder="" inputRef={register({ maxLength: 6}) } />
                    {errors.d_Complex && errors.d_Complex.type === "maxLength" && <span id="Err_msg">Max length is 6</span>}
                    {errors.d_Complex && errors.d_Complex.types && <span id="Err_msg">{errors.d_Complex.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-6-1" label="SPAN Version" labelFor="d_SpanSpecV">
                    <InputGroup id="d_SpanSpecV" name="d_SpanSpecV" defaultValue={MarketInfo.d_SpanSpecV} placeholder="" inputRef={register({ maxLength: 2}) } />
                    {errors.d_SpanSpecV && errors.d_SpanSpecV.type === "maxLength" && <span id="Err_msg">Max length is 2</span>}
                    {errors.d_SpanSpecV && errors.d_SpanSpecV.types && <span id="Err_msg">{errors.d_SpanSpecV.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-2" inline selectedValue={MarginCalcValue} label="Margin Calculation" onChange={utils.handleStringChange(s => setMarginCalcValue(s))}>
                    <Radio label="Simplified" value="0" />
                    <Radio label="SPAN" value="1" />
                </RadioGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Main. Margin %" subLabel="(% of Init. Margin for SPAN)" labelFor="d_OptMM">
                    <InputGroup id="d_OptMM" name="d_OptMM" defaultValue={"0"} type="number" placeholder="" inputRef={register({ min: 0}) } />
                    {errors.d_OptMM && errors.d_OptMM.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_OptMM && errors.d_OptMM.types && <span id="Err_msg">{errors.d_OptMM.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Client Margin Multiplier" labelFor="d_ClMgnMult">
                    <InputGroup id="d_ClMgnMult" name="d_ClMgnMult" defaultValue={"0"} type="number" placeholder="" inputRef={register({ min: 0}) } />
                    {errors.d_ClMgnMult && errors.d_ClMgnMult.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_ClMgnMult && errors.d_ClMgnMult.types && <span id="Err_msg">{errors.d_ClMgnMult.types.message}</span>}
                </FormGroup>
            </div>
        </form>
    )
}

interface FBSMarketMastMainProps {
    gsb: AxiosInstance
}

// const toaster = Toaster.create({
//     position: Position.TOP,
// })

function FBSMarketMastMain({ gsb }: FBSMarketMastMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { market: defaultSearchValue = "" }: { market: string } = useParams()

    const [isReadOnly, setisReadOnly] = useState(false)

    const [data, setData] = useState([] as FBSMarketInfo[])

    const [searchKey, setSearchKey] = useState("market")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)

    const [showFilters, setShowFilters] = useState(false)
    const [searchMarketName, setSearchMarketName] = useState("")
    
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentMarketInfo, setcurrentMarketInfo] = useState({} as FBSMarketInfo)

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                UserID = res.data.Flag.UserID
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) 
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        setisReadOnly(false)
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("MarketMastMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])



    const PrevRecProcess = async (MarketInfo: FBSMarketInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: MarketInfo, cPgmId: "MarketMast", cAction: "PrevRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Market === res.data.data.d_Market) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentMarketInfo(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (MarketInfo: FBSMarketInfo) => {
        try {
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/fbs/Master', {sb_data: MarketInfo, cPgmId: "MarketMast", cAction: "DelRec"})
            utils.showSuccess("Exchange " + MarketInfo.d_Market + " record deleted")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Market === res.data.data.d_Market) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentMarketInfo(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (MarketInfo: FBSMarketInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: MarketInfo, cPgmId: "MarketMast", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Market === res.data.data.d_Market) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentMarketInfo(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (MarketInfo: FBSMarketInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: MarketInfo, cPgmId: "MarketMast", cAction: "AddRec"})
            utils.showSuccess("Exchange " + res.data.data.d_Market + " record added")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Market === res.data.data.d_Market) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentMarketInfo(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (MarketInfo: FBSMarketInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: MarketInfo, cPgmId: "MarketMast", cAction: "UpdateRec"})
            utils.showSuccess("Exchange " + MarketInfo.d_Market + " record saved")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Market === res.data.data.d_Market) {
                    data[i] = { ...data[i], ...res.data.data }
                    //console.log("editOnSave data", i, data)
                    setData(data)
                    break
                }
            }
            //console.log("editOnSave res.data.data", res.data.data)
            setcurrentMarketInfo(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
        
        try {
            //console.log("MarketMastMain onsubmit called", data)
            if ( m_limit > 1 ) {
                const res = await gsb.post('/fbs/Master',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                            marketName: searchMarketName,
                        }, 
                    },
                    cPgmId: "MarketMast",
                    cAction: "ListRec",
                });

                //console.log("onSubmit res.data.data", res.data.data)
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentMarketInfo(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
    
            } else {
                const res = await gsb.post('/fbs/Master',
                {   sb_data: {
                        d_Market: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "MarketMast",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    //console.log("GetRec res.data.data", res.data.data)
                    setcurrentMarketInfo(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }

            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 
    
            (async () => {
                //console.log("MarketMastMain useEffect length > 0  called", data)
                const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: "market",
                            start: defaultSearchValue,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "MarketMast",
                        cAction: "ListRec",
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentMarketInfo(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue])

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                                marketName: searchMarketName,
                            }, 
                        },
                        cPgmId: "MarketMast",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setcurrentMarketInfo(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])
    

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    // currentMode = show
    let detail = <FBSMarketMastView gsb={gsb} MarketInfo={currentMarketInfo} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentMarketInfo)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentMarketInfo)} onNextRec={() => NextRecProcess(currentMarketInfo)}></FBSMarketMastView>
    switch (currentMode) {
        case "new":
            //console.log("currentMode = new")
            detail = <FBSMarketMastEdit gsb={gsb} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></FBSMarketMastEdit>
            break
        case "edit":
            //console.log("currentMode = edit")
            detail = <FBSMarketMastEdit gsb={gsb} MarketInfo={currentMarketInfo} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></FBSMarketMastEdit>
            break
        }

    let pagination = <Pagination nPage={nPage} nTotalPage={nTotalPage} aPageNumber={aPageNumber} setnPage={(n)=>setnPage(n)}></Pagination>
    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" disabled={isReadOnly} icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-100">Exchange</th>
                <th className="TCol-300">Name</th>
                <th className="TCol-100">Complex</th>
                <th className="TCol-100">Trade Date</th>
            </thead>
            <tbody id="ma_tr">
                {data.map((MarketInfo, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td onClick={() => { setcurrentMarketInfo(MarketInfo) ; MoblieDev && setSelectedTabId("detail") }}>{MarketInfo.d_Market}</td>
                        <td onClick={() => { setcurrentMarketInfo(MarketInfo) ; MoblieDev && setSelectedTabId("detail") }}>{MarketInfo.d_MarketName}</td>
                        <td onClick={() => { setcurrentMarketInfo(MarketInfo) ; MoblieDev && setSelectedTabId("detail") }}>{MarketInfo.d_Complex}</td>
                        <td onClick={() => { setcurrentMarketInfo(MarketInfo) ; MoblieDev && setSelectedTabId("detail") }}>{MarketInfo.d_TradeDate}</td>
                        {/* <td onClick={() => { setcurrentMarketInfo(MarketInfo) }}>{MarketInfo.d_Action}</td> */}
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Exchange Information</H3>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        {/* define search key */}
                        <FormGroup className="Col-1-5" label="Search for" labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="market">Market</option>
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "market"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "market"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>
                        </div>
                    <Collapse isOpen={showFilters}>
                        <div className="Row">
                            {/* define search filter */}
                            <FormGroup className="Col-1-2" label="Exchange Name" labelFor="searchMarketName">
                                <InputGroup id="searchMarketName" value={searchMarketName} onChange={utils.handleStringChange(s => setSearchMarketName(s.toUpperCase()))} />
                            </FormGroup>
                            {/* <FormGroup className="Col-6-2" label="No. of record(s) to List" labelFor="searchLimit" >
                                <InputGroup className="Input-XS" id="searchLimit" value={searchLimit.toString()} onChange={utils.handleNumberChange(n => setSearchLimit(n))} />
                            </FormGroup> */}
                        </div>
                    </Collapse>
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card>

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default FBSMarketMastMain